import { useEffect, useRef, useState } from "react";
import { usePlay, Panel, Label, Stat } from "./usePlay";
import { BetControl } from "@/components/game/BetControl";
import { fmtAZN } from "@/lib/api";
import { sfx } from "@/lib/sound";

export const LimboGame = ({ mode }) => {
  const { busy, play, finish } = usePlay(mode);
  const [bet, setBet] = useState(1);
  const [target, setTarget] = useState(2);
  const [shown, setShown] = useState(1);
  const [res, setRes] = useState(null);
  const raf = useRef();
  useEffect(() => () => cancelAnimationFrame(raf.current), []);
  const t = Math.min(1000, Math.max(1.01, Number(target) || 1.01));

  const go = async () => {
    setRes(null);
    const d = await play("/games/limbo", { bet, target: t });
    if (!d) return;
    const start = performance.now(), end = Math.min(d.result, 1e6);
    const tick = (now) => {
      const k = Math.min(1, (now - start) / 900);
      setShown(1 + (end - 1) * (1 - Math.pow(1 - k, 3)));
      if (k < 1) raf.current = requestAnimationFrame(tick);
      else { setShown(end); setRes(d); finish(d); }
    };
    sfx.reelTick();
    raf.current = requestAnimationFrame(tick);
  };

  return (
    <div className="grid lg:grid-cols-[340px_1fr] gap-6" data-testid="limbo-game">
      <Panel className="order-2 lg:order-1">
        <div><Label>Mərc</Label><BetControl value={bet} onChange={setBet} disabled={busy} testid="limbo-bet" /></div>
        <div><Label>Hədəf əmsal</Label>
          <input type="number" min="1.01" max="1000" step="0.01" disabled={busy} value={target} onChange={(e) => setTarget(e.target.value)} onBlur={() => setTarget(t)} className="jp-input text-center font-display" data-testid="limbo-target-input" />
          <div className="grid grid-cols-5 gap-1.5 mt-2">
            {[1.5, 2, 5, 10, 100].map((v) => <button key={v} disabled={busy} onClick={() => setTarget(v)} className={`rounded-lg py-1.5 text-xs font-semibold ${t === v ? "bg-[#D4AF37] text-black" : "bg-white/5 hover:bg-white/10"}`} data-testid={`limbo-preset-${v}`}>x{v}</button>)}
          </div>
        </div>
        <div className="grid grid-cols-2 gap-2"><Stat label="Şans" value={`${(97 / t).toFixed(2)}%`} testid="limbo-chance" /><Stat label="Qazanc" value={fmtAZN(bet * t)} /></div>
        <button disabled={busy} onClick={go} className="btn-gold w-full rounded-full py-4 font-display font-bold" data-testid="limbo-play-btn">Oyna</button>
      </Panel>
      <div className="order-1 lg:order-2 rounded-3xl min-h-[420px] relative overflow-hidden border border-white/10 flex flex-col items-center justify-center gap-4" style={{ background: "radial-gradient(circle at 50% 120%, #7B001C 0%, #1a0508 45%, #050505 80%)" }} data-testid="limbo-stage">
        <div className="absolute inset-0 opacity-30" style={{ backgroundImage: "radial-gradient(#fff 1px, transparent 1px)", backgroundSize: "40px 40px" }} />
        <p className={`relative font-display font-black text-6xl sm:text-8xl tabular-nums transition-colors ${res ? (res.won ? "text-emerald-400 drop-shadow-[0_0_30px_#10b981]" : "text-red-500 drop-shadow-[0_0_30px_#ef4444]") : "text-white"}`} data-testid="limbo-result">
          {shown >= 1000 ? Math.floor(shown).toLocaleString() : shown.toFixed(2)}x
        </p>
        <p className="relative text-white/60 text-sm">Hədəf: x{t.toFixed(2)}</p>
        <p className={`relative font-display font-bold text-xl h-7 ${res?.won ? "text-emerald-300" : "text-red-300"}`} data-testid="limbo-outcome">{res ? (res.won ? `+${fmtAZN(res.win)}` : "Uduzdunuz") : ""}</p>
      </div>
    </div>
  );
};
